import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import enTranslations from '../../assets/i18n/en.json';
import roTranslations from '../../assets/i18n/ro.json';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private translations: Record<string, any> = {
    en: enTranslations,
    ro: roTranslations,
  };
  private currentLanguage = new BehaviorSubject<string>('en');
  private supportedLanguages = ['en', 'ro'];

  public currentLanguage$ = this.currentLanguage.asObservable();

  constructor() {
    this.initializeLanguage();
  }

  private initializeLanguage(): void {
    const savedLanguage = localStorage.getItem('app-language');
    const browserLanguage = this.getBrowserLanguage();
    const defaultLanguage = savedLanguage || browserLanguage;

    if (this.supportedLanguages.includes(defaultLanguage)) {
      this.setLanguage(defaultLanguage);
    } else {
      this.setLanguage('en');
    }
  }

  private getBrowserLanguage(): string {
    const browserLang = navigator.language.split('-')[0];
    return this.supportedLanguages.includes(browserLang) ? browserLang : 'en';
  }

  setLanguage(language: string): void {
    if (!this.supportedLanguages.includes(language)) {
      console.warn(`Language ${language} is not supported. Using English instead.`);
      language = 'en';
    }

    localStorage.setItem('app-language', language);
    this.currentLanguage.next(language);
  }

  translate(key: string, language?: string): string {
    const lang = language || this.currentLanguage.value;
    const translation = this.translations[lang]?.[key];

    if (!translation) {
      console.warn(`Translation key '${key}' not found for language '${lang}'`);
      return key;
    }

    return translation;
  }

  getCurrentLanguage(): string {
    return this.currentLanguage.value;
  }

  getSupportedLanguages(): string[] {
    return this.supportedLanguages;
  }
}
